export default __webpack_public_path__ + "static/media/569.2c250180.png";